import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function FooterMobile() {
  return (
    <footer className="footer">
      <div className="footer-gradient-line" />
      <div className="footer-content">
        <span className="footer-copyright">© {new Date().getFullYear()} Eugen Dunca. All rights reserved.</span>
        <nav className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/experience">Contact</Link>
          <Link to="/energy">Energy</Link>
          <Link to="/robotics">Robotics</Link>
          <Link to="/arctic">Arctic</Link>
          <Link to="/about">About</Link>
        </nav>
        <div className="footer-contact">
          <span>Contact: <a href="mailto:edunca01.contact@gmail.com">edunca01.contact@gmail.com</a></span>
        </div>
      </div>
    </footer>
  );
}

export default FooterMobile;
